<button (click)="submit()" class="border-primary bg-white border rounded outline-none text-primary py-2 px-4 hover:bg-gray-200 focus:outline-none {{ classes }}">
  {{ name }}
</button>
